@if (pageResponse) {
  <div class="main-container">
    <div>
      Found <b>{{ tableData.filteredData.length }}</b> results
      @if (pageResponse.executionMillis) {
        <span> in {{ pageResponse.executionMillis }} seconds</span>
      }
      .
    </div>
    <div>
      @for (entry of aggs | keyvalue; track entry) {
        <span class="entry-container">
          <span class="entry-info">{{ entry.key }}</span>
          <b>{{ entry.value }}</b>
        </span>
      }
    </div>
  </div>
}
